export const CHART_COLORS = [
  'graph.brand.2',
  'graph.brand.3',
  'graph.brand.4',
  'graph.brand.5',
  'graph.brand.6',
  'graph.brand.7',
  'graph.brand.8',
  'graph.brand.9',
];

export const CHART_CONSTRAST_COLORS = [
  '#F4F4F4',
  '#F4F4F4',
  '#F4F4F4',
  '#F4F4F4',
  '#13141B',
  '#13141B',
  '#13141B',
  '#F4F4F4',
  '#F4F4F4',
  '#F4F4F4',
  '#F4F4F4',
  '#F4F4F4',
];

export const CHART_COLORS_ADVISORY = [
  'graph.brand.7',
  'graph.brand.5',
  'graph.brand.3',
  'graph.brand.2',
  'graph.blue',
  'pink.600',
];
